import zhCN from 'date-fns/locale/zh-CN';
const dateZhCN = {
    name: 'zh-CN',
    locale: zhCN
};
export default dateZhCN;
